import plur from 'plur'
import {memo} from 'react'
import {useLocation} from 'react-router-dom'

import {restApi} from '../../../../services/rest'
import type {ChangeId} from '../../../../types'
import {stringifyId} from '../../../../types'
import {queryToObject} from '../../../../utils/queryParams'
import {getChangeStatusArg} from '../../../packages/Changes/Changes.rest'

type Props = {
  className?: string
  changeId: ChangeId
}

function ChangeStatus({className, changeId}: Props) {
  const location = useLocation()
  const personal = queryToObject(location.search)?.personal === 'true'
  const locator = `id:${stringifyId(changeId)},personal:${personal}`

  const {isReady, changeStatus} = restApi.endpoints.getAllChangesKeyed.useQuery(
    getChangeStatusArg(locator),
    {
      selectFromResult: ({data}) => ({
        isReady: data != null,
        changeStatus: data?.[changeId]?.status,
      }),
    },
  )
  const {finishedBuilds = 0, runningBuilds = 0, pendingBuildTypes = 0} = changeStatus ?? {}

  let message = ''

  if (!isReady) {
    message = 'Loading...'
  } else if (finishedBuilds > 0 || runningBuilds > 0) {
    message = `${finishedBuilds} finished, ${runningBuilds} running, ${pendingBuildTypes} pending ${plur(
      'build',
      pendingBuildTypes,
    )}`
  } else {
    message = `No builds with this change have started yet (${pendingBuildTypes} pending)`
  }

  return <div className={className}>{message}</div>
}

export default memo<Props>(ChangeStatus)
